export default __webpack_public_path__ + "media/images/logos/safecontractor-logo-7496fbb522fa89c1a26730978f3da3c7.png";